import React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import { get } from "lodash";
import { FiFile, FiCode } from "react-icons/fi";

import IconHeader from "components/IconHeader";
import type { RootState } from "types/state";

interface OwnProps {
  onClose?: (...args: unknown[]) => void;
}

const mapStateToProps = (state: RootState) => {
  // employer.company is shallow-typed as Record<string, unknown> (that slice is
  // scheduled for deletion), so get() returns unknown — coerce to the
  // string|undefined the prop expects
  const payrollProvider = get(state.employer.company, "payrollProvider") as
    | string
    | undefined;
  return {
    payrollProvider,
  };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = WithApolloClient<OwnProps & PropsFromRedux>;

class AddDeductionCodeInstructions extends React.PureComponent<Props> {
  render() {
    const isGusto = this.props.payrollProvider === "gusto";
    const instructions = isGusto
      ? "https://support.iconsavingsplan.com/en/articles/8562334-how-to-setup-payroll-deductions-in-gusto"
      : "https://support.iconsavingsplan.com/en/articles/8562244-how-to-set-up-payroll-deductions";

    return (
      <>
        <div className="employerInfo">
          <div className="employerInfo-body" style={{ padding: 0 }}>
            <div>
              <div className="circle">
                <span className="icon">
                  <FiCode color="white" stroke="#60A4BF" size={16} />
                </span>
              </div>
            </div>
            <div className="employerInfo-intro">
              <IconHeader
                variant="labelHeader"
                headerText="Setup Deduction Code"
              />
            </div>
          </div>
          <div className="employerInfo-action">
            <span
              style={{
                display: "flex",
                color: "#01a3b0",
                cursor: "pointer",
              }}
            >
              <FiFile color="white" stroke="#60A4BF" size={16} />

              <a
                href={instructions}
                className="modal-link"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "flex",
                  color: "#01a3b0",
                  cursor: "pointer",
                  fontSize: 14,
                  paddingLeft: 5,
                }}
              >
                View Instructions
              </a>
            </span>
          </div>
        </div>
      </>
    );
  }
}

export default connector(withApollo<Props>(AddDeductionCodeInstructions));
